// Seeded random number generator for deterministic physics
export class SeededRandom {
  public seed: number;
  
  constructor(seed: number) {
    this.seed = (seed ^ 0x9e3779b9) >>> 0;
  }
  
  next(): number {
    let x = this.seed | 0;
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    this.seed = x >>> 0;
    return (this.seed >>> 0) / 4294967296;
  }
  
  nextFloat(min: number, max: number): number {
    return min + this.next() * (max - min);
  }
  
  nextBool(): boolean {
    return this.next() < 0.5;
  }
}